<template>
  <div id="app" :style="{'min-width':isPC?'1200px':''}">
    <router-view />
    <!-- <Watermark /> -->
  </div>
</template>

<script>
import { IsPC } from "@/utils/common";
// import Watermark from "@/components/Watermark/index.vue";

export default {
  name: "App",
  components: {
    // Watermark
  },
  data() {
    return {
      isPC: true,
    };
  },
  mounted() {
    this.isPC = IsPC();
  },
};
</script>
